module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy44ODkiIGhlaWdodD0iMTQuMDkxIiB2aWV3Qm94PSIwIDAgMTMuODg5IDE0LjA5MSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmM2E2Mjt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0tMSwxNC4wOTFIMTIuODg5VjBoLTJWMTIuMDkxSC0xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSkiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/08rightRed.svg
// module id = lYP0
// module chunks = 1